import * as types from './actionsTypes';

export type SaveAravotActionType = {
  type: string;
  kind: string;
  price: string | number;
  headers: any;
  onSuccess?: () => void;
};

export const saveAravotAction = (
  kind: string,
  price: string | number,
  headers: any,
  onSuccess?: () => void
): SaveAravotActionType => ({
  type: types.SAVE_NEW_ARAVOT,
  kind,
  price,
  headers,
  onSuccess,
});
